import httpClient from '@/api/httpClient'

export class SimulationApi {
  static async create(form) {
    try {
      const res = await httpClient.post('/simulation', form)
      return res.data
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  static async getByConditionHash(conditionHash) {
    try {
      const res = await httpClient.get(`/simulation/${conditionHash}`)
      return res.data
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  static async getCsvByConditionHash(conditionHash, encode) {
    try {
      const res = await httpClient.get(`/simulation/${conditionHash}/csv`, {
        params: { encode },
      })
      return res.data
    } catch (e) {
      console.error(e)
      throw e
    }
  }
}
